import CategoryResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MeditationService/CategoryResponse";

export default class CategoryViewModel {
    id: number;
    name: string;
    constructor(obj?: CategoryResponse) {
        if (obj != null) {
            this.id = obj.Id;
            this.name = obj.Translations[0].Name;
        }
    }
}